import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

// 应用入口：挂载 React 根组件
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('找不到根节点 #root，请检查 index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
